import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { pure } from 'recompose';

const OutIcon = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 32px;
  height: 30px;
  margin-left: -10px;
  background-image: url(/assets/images/route-arrows.png);
  background-repeat: no-repeat;
  background-size: 64px;
  background-position: 0px -2px;
`;
const HomeIcon = OutIcon.extend`
  background-position: -32px -2px;
`;

const Icon = pure(({ first, last }) => {
  if (first) {
    return <OutIcon />;
  }
  if (!first && last) {
    return <HomeIcon />;
  }
  return <span />;
});
Icon.propTypes = {
  first: PropTypes.bool,
  last: PropTypes.bool,
};
export { Icon };



// WEBPACK FOOTER //
// ./src/components/organisms/DepartureSelectorGroup/Icon.js